
import { Vue, Component, Prop } from "vue-property-decorator";
import { ImagePath } from "../views/ImagePath";
import Garally from "@components/Garally.vue";
import Config from "../../config.d";
Vue.prototype.$filterKeyword = "";
@Component({ components: {} })
export default class SideBar extends Vue {
  private inputMessage = "";
  private filterKeyword = "";
  private filterKeyword2 = "";

  @Prop({ default: [] })
  images!: ImagePath[];

  /* get imagesModel() {
    return this.images.filter(
      (item) =>
        this.$filterKeyword.filter1 == "" ||
        (item.class !== this.$filterKeyword.filter1 &&
          item.class !== this.$filterKeyword.filter2)
    );
  } */

  private filterB() {
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
    this.$filterKeyword.filter1 = "3dmodel";
    this.$filterKeyword.filter2 = "arprogram";
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
  }
  private filterA() {
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
    this.$filterKeyword.filter1 = "vrprogram";
    this.$filterKeyword.filter2 = "arprogram";
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
  }
  private filterC() {
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
    this.$filterKeyword.filter1 = "3dmodel";
    this.$filterKeyword.filter2 = "vrprogram";
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
  }
  private clearFilter() {
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
    this.$filterKeyword.filter1 = "";
    this.$filterKeyword.filter2 = "";
    console.log(this.$filterKeyword.filter1, this.$filterKeyword.filter2);
  }
}
